import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {CommonService} from "../../../core/service/common.service";
import {MokuhyouTemperatureRow} from "../../interfaces/mokuhyou-tempreture";

@Component({
  selector: 'app-mokuhyou-temperature-master-dialog',
  templateUrl: './mokuhyou-temperature-master-dialog.component.html',
  styleUrls: ['./mokuhyou-temperature-master-dialog.component.scss']
})
export class MokuhyouTemperatureMasterDialogComponent {
  meisai: MokuhyouTemperatureRow;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MokuhyouTemperatureRow,
    public commonService: CommonService,
    public matDialogRef: MatDialogRef<MokuhyouTemperatureMasterDialogComponent>
  ) {
    this.meisai = {...this.data};
  }

  /**
   * 最低温度、最高温度設定バリデーションチェック
   * 明細を返す
   */
  register() {
    if (this.meisai.lowTemperature >= this.meisai.highTemperature) {
      alert('気温を正しく入力してください。');
      return;
    }
    this.commonService.onClick(this.matDialogRef, this.meisai);
  }
}
